import React, { useState } from "react";
import * as moment from "moment";
import { toast } from "react-toastify";

import { Util } from "../../../../../../../helpers/util";
import { SuccessModal } from "../../../../../../modals/success-modal/success.modal";
import { $api } from "../../../../../../../helpers/$api";

const SavingsSummary = ({
  setChange,
  wallet,
  amount,
  frequency,
  end_date,
  id,
}) => {
  const { currency } = Util.getCurrency();
  const [show, setShow] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleConfirmClick = async () => {
    if (submitting) {
      return;
    }
    try {
      setSubmitting(true);
      const res = await $api.user.withdrawSavest(id, amount);

      console.log(res);
      setShow(true);
    } catch (error) {
      toast.error(`error initiating withdrawal - ${error.message}`);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="create-flexible-plan">
      <div className="create-flexible-plan-main">
        <div className="create-flexible-header">
          <h5 className="create-flexible-h5">Confirm Details</h5>
        </div>
        <div className="silverplan">
          <h5 className="silverplan-header">Withdraw Summary</h5>
          <div className="silverplan-flex">
            <div className="investamount">
              <p className="flex-main">Amount Saved:</p>
              <p className="pricetag">
                {currency}
                {Util.formatMoneyNumber(wallet)}
              </p>
            </div>
            <div className="investamount">
              <p className="flex-main">Interest Earned:</p>
              <p className="flex-mini">
                {currency}
                {Util.formatMoneyNumber(wallet + wallet * 0.07)}
              </p>
            </div>
            <div className="investamount">
              <p className="flex-main">Amount to Withdraw</p>
              <p className="flex-mini">
                {currency}
                {Util.formatMoneyNumber(amount)}
              </p>
            </div>
            <div className="investamount">
              <p className="flex-main">Balance after Withdrawal:</p>
              <p className="flex-mini">
                {currency}
                {Util.formatMoneyNumber(wallet - amount)}
              </p>
            </div>
            <div className="investamount">
              <p className="flex-main">Saving Frequency:</p>
              <p className="flex-mini">{frequency}</p>
            </div>
            <div className="investamount">
              <p className="flex-mini">Completion Date:</p>
              <p className="pricetag-mini">
                {moment(end_date).format("DD MMMM, YYYY")}
              </p>
            </div>
          </div>
        </div>
        <button onClick={handleConfirmClick} className="savest-button mb-2">
          Confirm
        </button>
      </div>
      <SuccessModal
        url="/dashboard"
        show={show}
        message="withdraw successful!"
        onCloseClick={() => setShow(false)}
      />
    </div>
  );
};

export default SavingsSummary;
